/**
 * The session, handed to the screens through context rather than through props.
 *
 * Author: Mahmoud Ragab Ahmed.
 *
 * A screen that needs the token takes it from here and never from anywhere else. The
 * token is a credential for the API and nothing more: no screen reads it to decide
 * anything about the person, because the server has not been asked and the client does
 * not get an opinion.
 */

import { createContext, useContext } from "react";

import type { Session } from "./session";

export const SessionContext = createContext<Session | null>(null);

/** The access token for this tab's session, or the refusal of a bug at the call site. */
export function useToken(): string {
  const session = useContext(SessionContext);
  if (session === null) {
    throw new Error("A screen asked for the session outside a signed-in shell");
  }
  return session.accessToken;
}
